/**
 * Pharmacy notification rows in the topbar panel (design/ux/01_foundations.md
 * §6.2, §6.14; AUD-NAV-16, AUD-NAV-22; WP-18). Pure.
 */

/** Server `niveau` (SUCCESS | WARNING | ERROR | INFO, or a legacy `severity`) → tone. */
export function notificationTone(n) {
  const raw = String(n?.niveau ?? n?.severity ?? "").toUpperCase();
  if (raw === "ERROR" || raw === "DANGER") return "danger";
  if (raw === "WARNING") return "warning";
  if (raw === "SUCCESS") return "success";
  return "info";
}

export const NOTIFICATION_TONE_ICON = Object.freeze({
  danger: "alert-octagon",
  warning: "alert-triangle",
  success: "check-circle",
  info: "info",
});

/** Words read with the row (the tone is never colour alone). */
export const NOTIFICATION_TONE_LABEL = Object.freeze({
  danger: "Erreur",
  warning: "Attention",
  success: "Succès",
  info: "Information",
});

export const isNotificationRead = (n) => Boolean(n?.read ?? n?.lue);

/**
 * Where a row leads: the server's `action_url` (current shape), else the
 * legacy `action.page` key (+ id) through the page-key table; null = no target.
 * Only in-app paths are followed (a row never navigates off the application).
 * @param {any} n
 * @param {(page: string) => string} pageToPath
 */
export function notificationTarget(n, pageToPath) {
  const url = n?.action_url;
  if (typeof url === "string" && url.startsWith("/") && !url.startsWith("//")) return url;
  const page = n?.action?.page;
  if (page) {
    const base = pageToPath(page);
    const id = n.action.id;
    return id != null && id !== "" ? `${base}/${encodeURIComponent(String(id))}` : base;
  }
  return null;
}
